import { BaseResource } from './base-resource';

export class TranslationResource extends BaseResource {
  readonly language: string;
  readonly name: string;
  readonly defaultLanguage: boolean;
}
